
    // **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "float",
        regionType:  "region_name_currency_symbol",
        floatingPosition: "top_left",
        floatingPaddingHorizontal:  15,
        floatingPaddingVertical:  15,
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "yes",
        selectorFlagMap: {'it': 'it', 'fr': 'fr', 'de': 'de', 'pt-PT': 'pt-PT', 'en': 'en', 'es': 'es'},
        displayType: "language_name",
        fontColor: "#000000",
        backgroundColor: "#FFFFFF",
        backgroundOpacity: "1.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",    
        defaultRegion: "DE",    
        primaryRegionById: {},    
        availableRegionsByCode: {},    
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "Germany", "code": "DE", "currency": {"code": "EUR", "symbol": "\u20ac"}, "languages": {"Deutsch": {"name": "Deutsch (German)", "native_name": "Deutsch", "code": "de", "default": true}, "English": {"name": "English", "native_name": "English", "code": "en", "default": false}, "Fran\u00e7ais": {"name": "Fran\u00e7ais (French)", "native_name": "Fran\u00e7ais", "code": "fr", "default": false}, "Italiano": {"name": "Italiano (Italian)", "native_name": "Italiano", "code": "it", "default": false}, "Espa\u00f1ol": {"name": "Espa\u00f1ol (Spanish)", "native_name": "Espa\u00f1ol", "code": "es", "default": false}, "Portugu\u00eas": {"name": "portugu\u00eas (Portugal Portuguese)", "native_name": "Portugu\u00eas", "code": "pt-PT", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
    